<template>
  <div>
    <v-dialog
      :ref="name"
      v-model="show"
      :return-value.sync="output"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="output"
          :label="label"
          readonly
          v-on="on"
          :dense="dense"
        ></v-text-field>
      </template>
      <v-date-picker v-model="output" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="show = false">Cancel</v-btn>
        <v-btn text color="primary" @click="$refs[name].save(output)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'DateFieldWidget',
      props: {
          name: {
              type: String,
              required: true
          },
          label: {
              type: String,
              default: "date"
          },
          dense: {
              type: Boolean,
              default: false
          },
          startDate: {
              type: String,
              default: new Date().toISOString().substr(0, 10)
          }

      },
      data() {
        return {
            show: false,
            output: this.startDate
        }
      },
      watch:{
        output(newValue){
            this.$emit('update:startDate', newValue);
        },
        startDate(newValue, oldValue) {
             if(newValue !== oldValue) {
               this.output = newValue;
             }
        }
      },
      methods:{
      }
  }
</script>

<style lang="scss">
</style>
